module.exports = __webpack_public_path__ + "static/media/box.3fd1906a.svg";